class UUIEvent extends Event {
  constructor(evName, eventInit = {}) {
    super(evName, { ...eventInit });
    this.detail = eventInit.detail || {};
  }
}

class UUIFormControlEvent extends UUIEvent {
  constructor(evName, eventInit = {}) {
    super(evName, {
      ...{ bubbles: true },
      ...eventInit
    });
  }
  static {
    this.VALID = "valid";
  }
  static {
    this.INVALID = "invalid";
  }
}

class UUISelectableEvent extends UUIEvent {
  static {
    this.SELECTED = "selected";
  }
  static {
    this.DESELECTED = "deselected";
  }
  constructor(evName, eventInit = {}) {
    super(evName, {
      ...{ bubbles: true, cancelable: true },
      ...eventInit
    });
  }
}

export { UUIEvent, UUIFormControlEvent, UUISelectableEvent };
